module.exports = __webpack_public_path__ + "static/aon-savings--mobile-e3e5391d8bded46eeb86df4b492e38c5.png";